(function($){
  
$(document).ready(function(){
   
    $('.details-plus').click(function () {
      $('.details-plus').addClass("out");
      $('.details-minus').removeClass("out");
      $('.details-data').removeClass("oculto");
    });  
    
    $('.details-minus').click(function () {
      $('.details-minus').addClass("out");
      $('.details-plus').removeClass("out");
      $('.details-data').addClass("oculto");
    });
    
    $('.delivery-plus').click(function () {
      $('.delivery-plus').addClass("out");
      $('.delivery-minus').removeClass("out");
      $('.delivery-data').removeClass("oculto");
    });  
    
    $('.delivery-minus').click(function () {
      $('.delivery-minus').addClass("out");
      $('.delivery-plus').removeClass("out");
      $('.delivery-data').addClass("oculto");
    });

  });
})(jQuery);

let faqInfo = document.querySelectorAll('.faq__info');
if(faqInfo){
  for (let i = 0; i < faqInfo.length; i++) {
    faqInfo[i].addEventListener("click", function() {
      let firstElem = faqInfo[i].firstElementChild
      let faqArrow = firstElem.lastElementChild;
      faqArrow.classList.toggle("rotate");
      let faqData = faqInfo[i].lastElementChild; 
      faqData.classList.toggle("fuera");
    });
  }
}

let forgotPass = document.querySelector('.forgotPassword');
let logIn = document.querySelector('.login');
let forgot = document.querySelector('.forgot');
if (forgotPass) {
  forgotPass.addEventListener("click", function(){
    logIn.classList.add("fuera");
    forgot.classList.remove("fuera");
  });  
}

let ordersButton = document.querySelector('.orders');
let detailsButton = document.querySelector('.details');
let addressesButton = document.querySelector('.addresses');
let editButton = document.querySelector('.edit');
let accountOrders = document.querySelector('.account__orders');
let accountDetails = document.querySelector('.account__details');
let accountAddresses = document.querySelector('.account__addresses');
if (ordersButton) {
  ordersButton.addEventListener("click", function(){
    accountOrders.classList.remove("fuera");
    accountDetails.classList.add("fuera");
    accountAddresses.classList.add("fuera");
    ordersButton.classList.add("bold");
    detailsButton.classList.remove("bold");
    addressesButton.classList.remove("bold");
  });
}
if (detailsButton) {
  detailsButton.addEventListener("click", function(){
    accountDetails.classList.remove("fuera");
    accountOrders.classList.add("fuera");
    accountAddresses.classList.add("fuera");
    detailsButton.classList.add("bold");
    ordersButton.classList.remove("bold");
    addressesButton.classList.remove("bold");
  });
}
if (addressesButton) {
  addressesButton.addEventListener("click", function(){
    showAddresses();
  });
  editButton.addEventListener("click", function(){
    showAddresses();
  });
}
function showAddresses(){
    accountAddresses.classList.remove("fuera");
    accountOrders.classList.add("fuera");
    accountDetails.classList.add("fuera");
    addressesButton.classList.add("bold");
    ordersButton.classList.remove("bold");
    detailsButton.classList.remove("bold");
}
let editAddress = document.querySelectorAll('.editAddressBtn')
let adressContainer = document.querySelectorAll('.addresses__container')
if(editAddress){
  for (let i = 0; i < editAddress.length; i++) {
    editAddress[i].addEventListener("click", function() {
      for (let i = 0; i < adressContainer.length; i++) {
        adressContainer[i].classList.add("fuera")
      }
    });
  }
}
let cancelBtn = document.querySelectorAll('.cancelBtn')
if(cancelBtn){
  for (let i = 0; i < cancelBtn.length; i++) {
    cancelBtn[i].addEventListener("click", function() {
      if(adressContainer){
        for (let i = 0; i < adressContainer.length; i++) {
          adressContainer[i].classList.remove("fuera")
        }     
      }
    });
  }
}

if (window.innerWidth < 950){
    $(".home-video-small").removeClass("fuera")
    $(".home-video").addClass("fuera")
}
function videoHomeResize() {
  if (window.innerWidth < 950){
    $(".home-video-small").removeClass("fuera")
    $(".home-video").addClass("fuera")
  }else{
    $(".home-video-small").addClass("fuera")
    $(".home-video").removeClass("fuera")
  }
}
window.onresize = videoHomeResize;

$('#shopify-section-1663760517d283d5f6 .grid-uniform').slick({
  dots: true,
  infinite: true,
  speed: 1200,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 850,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

/* ============================================================
   BAGOUVE CART REDESIGN — nueva lógica del carrito
   ------------------------------------------------------------
   Todo el código de esta sección es nuevo y vive aquí a propósito
   (y no en theme.js / theme.js.liquid) para no tocar el plugin
   original del carrito. Se engancha exclusivamente al evento
   "ajaxCart.afterCartLoad" que el propio plugin dispara en
   $('body') cada vez que el carrito se actualiza (añadir, quitar,
   cambiar cantidad, etc.), así que no hace falta duplicar ni
   adivinar su lógica interna.

   Índice:
   1. Utilidades (formatMoney)
   2. Barra de envío gratis
   3. Collect & Save (upsell): clonado, filtrado y toggle de título
   4. Popup de selección de talla + add to cart del upsell
   5. Código de descuento
   6. Estado de carrito vacío
   7. Orquestación
   ============================================================ */
(function ($) {
  'use strict';

  if (!window.theme) window.theme = {};

  /* ------------------------------------------------------------
     1. Utilidades
  ------------------------------------------------------------ */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || (theme.strings && theme.strings.moneyFormat) || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;

      if (isNaN(number) || number == null) return 0;

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    var match = formatString.match(placeholderRegex);
    if (!match) return formatString;

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }
  theme.formatMoney = formatMoney;

  /* ------------------------------------------------------------
     2. Barra de envío gratis (SSR + actualización en vivo)
  ------------------------------------------------------------ */
  function updateFreeShippingBar(cart) {
    var bar = document.querySelector('[data-cart-shipping-bar]');
    if (!bar) return;

    var threshold = (theme.settings && theme.settings.cartFreeShippingThresholdCents) || 0;
    if (!threshold) return;

    bar.classList.remove('cart-shipping-bar--empty');

    var remaining = threshold - cart.total_price;
    if (remaining < 0) remaining = 0;

    var percent = (cart.total_price / threshold) * 100;
    if (percent > 100) percent = 100;
    if (percent < 0) percent = 0;

    var fill = bar.querySelector('[data-cart-shipping-fill]');
    if (fill) fill.style.width = percent + '%';

    var message = bar.querySelector('[data-cart-shipping-message]');
    if (message) {
      if (remaining > 0) {
        var amount = formatMoney(remaining, theme.strings.moneyFormat);
        message.innerHTML = theme.strings.cartFreeShippingRemaining.replace('[amount]', amount);
        bar.classList.remove('cart-shipping-bar--unlocked');
      } else {
        message.innerHTML = theme.strings.cartFreeShippingUnlocked;
        bar.classList.add('cart-shipping-bar--unlocked');
      }
    }
  }

  // Carrito vacío: la barra pasa a mostrar el mensaje fijo "Free
  // shipping on orders above X" (umbral del país del visitante),
  // en gris y sin progreso, en vez de ocultarse.
  function renderEmptyShippingBar() {
    var bar = document.querySelector('[data-cart-shipping-bar]');
    if (!bar) return;

    var threshold = (theme.settings && theme.settings.cartFreeShippingThresholdCents) || 0;
    if (!threshold) return;

    bar.classList.remove('cart-shipping-bar--unlocked');
    bar.classList.add('cart-shipping-bar--empty');

    var fill = bar.querySelector('[data-cart-shipping-fill]');
    if (fill) fill.style.width = '0%';

    var message = bar.querySelector('[data-cart-shipping-message]');
    if (message && theme.strings.cartFreeShippingThreshold) {
      var amount = formatMoney(threshold, theme.strings.moneyFormat);
      message.innerHTML = theme.strings.cartFreeShippingThreshold.replace('[amount]', amount);
    }
  }

  /* ------------------------------------------------------------
     3. Collect & Save (upsell): clonar plantilla, filtrar
        productos ya presentes en el carrito y togglear título
  ------------------------------------------------------------ */
  function renderCollectSave(cart) {
    var slot = document.getElementById('CollectSaveSlot');
    var tpl = document.getElementById('CollectSaveTemplate');
    if (!slot || !tpl) return;

    slot.innerHTML = '';
    slot.appendChild(tpl.content.cloneNode(true));

    var cartProductIds = cart.items.map(function (item) {
      return String(item.product_id);
    });

    // Máximo 4 productos visibles, y solo los que NO estén ya en
    // el carrito. La colección puede tener más de 4 a propósito
    // (margen por si algunos ya están en el carrito); el resto se
    // oculta, no se recorta la colección en Shopify.
    var MAX_VISIBLE = 4;
    var items = slot.querySelectorAll('[data-collect-save-item]');
    var visibleCount = 0;
    // El último HIJO en el DOM no tiene por qué ser el último item
    // VISIBLE (los ocultamos con display:none según lo que ya haya
    // en el carrito, no los quitamos del DOM), así que ":last-child"
    // en CSS no sirve aquí. Marcamos a mano cuál es el último
    // visible con una clase, y solo a ese le damos el margen extra.
    var lastVisibleItem = null;
    for (var i = 0; i < items.length; i++) {
      var productId = items[i].getAttribute('data-product-id');
      var alreadyInCart = cartProductIds.indexOf(productId) !== -1;
      items[i].classList.remove('cart-collect-save__item--last-visible');
      if (!alreadyInCart && visibleCount < MAX_VISIBLE) {
        items[i].style.display = '';
        visibleCount++;
        lastVisibleItem = items[i];
      } else {
        items[i].style.display = 'none';
      }
    }
    if (lastVisibleItem) {
      lastVisibleItem.classList.add('cart-collect-save__item--last-visible');
    }

    // Si no queda ningún producto de upsell disponible, ocultamos
    // toda la sección (ya no aporta nada).
    var wrapper = slot.querySelector('.cart-collect-save');
    if (wrapper) {
      wrapper.style.display = visibleCount > 0 ? '' : 'none';
    }

    // Título: "Collect & Save" -> "Collector's Privilege" cuando
    // el carrito ya tiene 3 o más artículos (BUNDLE15 desbloqueado).
    var titleEl = slot.querySelector('[data-collect-save-title]');
    if (titleEl) {
      titleEl.textContent = cart.item_count >= 3
        ? theme.strings.collectSaveTitleUnlocked
        : theme.strings.collectSaveTitle;
    }

    bindCollectSaveAddButtons(slot);
    bindCollectSaveDragScroll(slot);
  }

  /* ------------------------------------------------------------
     3b. Collect & Save: arrastrar con el ratón en escritorio
     ------------------------------------------------------------
     El scroll horizontal (".cart-collect-save__list") solo se podía
     mover con touch/trackpad/rueda del ratón; con el ratón "a
     secas" (clic y arrastrar) no pasaba nada, porque el scroll
     nativo del navegador no lo interpreta como gesto de scroll. Se
     simula aquí moviendo "scrollLeft" a mano mientras el botón siga
     pulsado.

     "mousemove"/"mouseup" van en "document", NO en la propia lista:
     si se enganchan solo al elemento, mover el ratón rápido en
     horizontal (algo normalísimo al arrastrar) hace que el cursor
     se salga un instante de los ~130px de alto de la lista, dispara
     "mouseleave" y corta el arrastre a medias — eso es justo lo que
     se sentía como "lag"/tirones: el drag se interrumpía solo y
     había que soltar y volver a empezar. Con los listeners en
     "document" el arrastre sigue mientras el botón del ratón siga
     pulsado, esté el cursor donde esté.

     El estado del arrastre ("dragScroll") vive en el ámbito del
     módulo, no dentro de esta función: los listeners de "document"
     se instalan UNA sola vez (más abajo, fuera de
     bindCollectSaveDragScroll). Si se instalaran de nuevo en cada
     render de Collect & Save, se irían acumulando copias sueltas
     cada vez que se añade/quita un producto del carrito.

     El "scrollLeft" se aplica directamente en cada "mousemove", sin
     ningún retraso ni "suavizado" de por medio (se probó a aplicarlo
     vía requestAnimationFrame para ahorrar trabajo, pero eso metía
     hasta un frame de retraso entre el movimiento real del ratón y
     el scroll, y se notaba como tirones — justo lo contrario de lo
     que buscaba). Aplicarlo al momento es lo que hace que el
     contenido se sienta pegado al cursor.

     "moved" evita que un arrastre termine disparando el click de un
     enlace o botón de dentro (p.ej. "ADD TO CART") justo al soltar
     el ratón: si hubo movimiento de verdad, se cancela ese click.
     El "dragstart" nativo de las imágenes se desactiva porque si no
     el navegador intenta arrastrar la propia imagen (su "fantasma"
     al arrastrar) en vez de dejar que se mueva el scroll.
  ------------------------------------------------------------ */
  var dragScroll = {
    active: false,
    list: null,
    moved: false,
    startX: 0,
    startScrollLeft: 0
  };

  document.addEventListener('mousemove', function (evt) {
    if (!dragScroll.active) return;
    evt.preventDefault();
    var walk = evt.pageX - dragScroll.startX;
    if (Math.abs(walk) > 5) dragScroll.moved = true;
    dragScroll.list.scrollLeft = dragScroll.startScrollLeft - walk;
  });

  document.addEventListener('mouseup', function () {
    if (!dragScroll.active) return;
    dragScroll.active = false;
    if (dragScroll.list) dragScroll.list.classList.remove('is-dragging');
  });

  function bindCollectSaveDragScroll(scope) {
    var list = scope.querySelector('.cart-collect-save__list');
    if (!list) return;

    list.addEventListener('mousedown', function (evt) {
      if (evt.button !== 0) return; // solo clic izquierdo
      evt.preventDefault(); // evita seleccionar texto/imagen al arrastrar rápido
      dragScroll.active = true;
      dragScroll.moved = false;
      dragScroll.list = list;
      dragScroll.startX = evt.pageX;
      dragScroll.startScrollLeft = list.scrollLeft;
      list.classList.add('is-dragging');
    });

    // Captura (tercer argumento "true"): hace falta interceptar el
    // click ANTES de que llegue al enlace/botón real de dentro.
    list.addEventListener('click', function (evt) {
      if (dragScroll.moved && dragScroll.list === list) {
        evt.preventDefault();
        evt.stopPropagation();
      }
    }, true);

    list.addEventListener('dragstart', function (evt) {
      evt.preventDefault();
    });
  }

  /* ------------------------------------------------------------
     4. Popup de selección de talla + add to cart del upsell
  ------------------------------------------------------------ */
  function bindCollectSaveAddButtons(scope) {
    var buttons = scope.querySelectorAll('[data-collect-save-add]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', (function (button) {
        return function (evt) {
          evt.preventDefault();
          openSizePopup(button);
        };
      })(buttons[i]));
    }
  }

  // Talla actualmente seleccionada en el popup (se resetea cada vez
  // que se abre para un producto nuevo). El popup NO añade nada al
  // carrito al pulsar una talla: solo la marca como seleccionada.
  // Hace falta pulsar el botón "ADD TO CART" del propio popup.
  var sizePopupSelectedVariantId = null;

  function openSizePopup(button) {
    var popup = document.getElementById('CartSizePopup');
    if (!popup) return;

    sizePopupSelectedVariantId = null;

    var variants = [];
    try {
      variants = JSON.parse(button.getAttribute('data-variants'));
    } catch (e) {
      variants = [];
    }

    var titleEl = popup.querySelector('[data-size-popup-title]');
    if (titleEl) titleEl.textContent = button.getAttribute('data-product-title') || '';

    var imageEl = popup.querySelector('[data-size-popup-image]');
    var productImage = button.getAttribute('data-product-image');
    if (imageEl && productImage) imageEl.setAttribute('src', productImage);

    // Precio: se toma de la primera variante disponible (o la
    // primera si no hay ninguna disponible) para mostrar algo
    // razonable antes de que el cliente elija talla.
    var referenceVariant = variants[0];
    for (var v = 0; v < variants.length; v++) {
      if (variants[v].available) { referenceVariant = variants[v]; break; }
    }
    var priceEl = popup.querySelector('[data-size-popup-price]');
    var comparePriceEl = popup.querySelector('[data-size-popup-compare-price]');
    if (referenceVariant && priceEl) {
      priceEl.textContent = formatMoney(referenceVariant.price, theme.strings.moneyFormat);
      if (comparePriceEl) {
        if (referenceVariant.compare_at_price && referenceVariant.compare_at_price > referenceVariant.price) {
          comparePriceEl.textContent = formatMoney(referenceVariant.compare_at_price, theme.strings.moneyFormat);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.textContent = '';
          comparePriceEl.style.display = 'none';
        }
      }
    }

    var optionsEl = popup.querySelector('[data-size-popup-options]');
    if (optionsEl) {
      optionsEl.innerHTML = '';
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var optionButton = document.createElement('button');
        optionButton.type = 'button';
        optionButton.className = 'cart-size-popup__option';
        optionButton.textContent = variant.title;
        optionButton.setAttribute('data-variant-id', variant.id);
        if (!variant.available) {
          optionButton.classList.add('cart-size-popup__option--disabled');
          optionButton.disabled = true;
        } else {
          optionButton.addEventListener('click', (function (variantId, optionEl) {
            return function () {
              sizePopupSelectedVariantId = variantId;
              var siblings = optionsEl.querySelectorAll('.cart-size-popup__option');
              for (var s = 0; s < siblings.length; s++) {
                siblings[s].classList.remove('is-selected');
              }
              optionEl.classList.add('is-selected');
              var addButton = popup.querySelector('[data-size-popup-add]');
              if (addButton) addButton.disabled = false;
            };
          })(variant.id, optionButton));
        }
        optionsEl.appendChild(optionButton);
      }
    }

    var addButton = popup.querySelector('[data-size-popup-add]');
    if (addButton) addButton.disabled = true;

    popup.classList.add('is-active');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-size-popup-open');
  }

  function closeSizePopup() {
    var popup = document.getElementById('CartSizePopup');
    if (!popup) return;
    popup.classList.remove('is-active');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-size-popup-open');
    sizePopupSelectedVariantId = null;
  }

  function addUpsellVariantToCart(variantId) {
    if (!variantId) return;
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { id: variantId, quantity: 1 },
      dataType: 'json',
      success: function () {
        // El carrito ya está abierto en este punto (el popup de
        // talla solo se puede abrir desde dentro del carrito), así
        // que basta con refrescar su contenido. Antes también se
        // simulaba un click en el icono del carrito del header para
        // "reabrirlo" por seguridad, pero ese click reactivaba el
        // enlace <a href="/cart"> y era lo que cerraba/navegaba el
        // carrito justo después de añadir el producto.
        closeSizePopup();
        refreshCart();
      },
      error: function () {
        // Silencioso: si falla (p.ej. sin stock), el popup se queda
        // abierto para que el cliente pueda elegir otra talla.
      }
    });
  }

  /* ------------------------------------------------------------
     5. Código de descuento
     Shopify no permite aplicar códigos de descuento por AJAX: el
     único mecanismo que existe es /discount/CODE?redirect=X, una
     URL normal (no un endpoint JSON) que fija el descuento mediante
     una cookie de sesión y responde con un redirect de página
     completa. Para no navegar fuera de la página actual (ni cerrar
     el drawer), esa URL se carga en un <iframe> oculto en vez de en
     la ventana visible: el navegador la visita "en segundo plano",
     con la misma cookie de la tienda (mismo dominio, sin problema de
     cookies de terceros), y en cuanto el iframe termina de cargar
     refrescamos el carrito por AJAX — mismo resultado que volver de
     /discount/CODE, sin salir nunca del carrito.
  ------------------------------------------------------------ */
  function applyDiscountCode(code, button) {
    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.setAttribute('aria-hidden', 'true');

    var settled = false;
    function finish() {
      if (settled) return;
      settled = true;
      if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
      if (button) button.disabled = false;
      refreshCart();
    }

    iframe.addEventListener('load', finish);
    // Salvavidas por si el iframe nunca dispara "load" (código
    // inválido, red lenta, bloqueo del navegador...): no dejamos el
    // botón bloqueado para siempre.
    setTimeout(finish, 4000);

    if (button) button.disabled = true;
    iframe.src = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    document.body.appendChild(iframe);
  }

  function bindDiscountCode(scope) {
    var input = scope.querySelector('[data-discount-code-input]');
    var button = scope.querySelector('[data-discount-code-apply]');
    if (!input || !button || input.getAttribute('data-bound') === 'true') return;

    function applyCode() {
      var code = input.value.trim();
      if (!code) return;
      applyDiscountCode(code, button);
    }

    button.addEventListener('click', applyCode);
    input.addEventListener('keydown', function (evt) {
      if (evt.key === 'Enter') {
        evt.preventDefault();
        applyCode();
      }
    });
    input.setAttribute('data-bound', 'true');
  }

  /* ------------------------------------------------------------
     6. Estado de carrito vacío
     buildCart() (en theme.js/theme.js.liquid, que no tocamos)
     pinta un mensaje mínimo cuando el carrito está vacío. Lo
     sobreescribimos aquí con el diseño nuevo justo después de
     cada actualización del carrito.
  ------------------------------------------------------------ */
  function renderEmptyCart(cart) {
    var container = document.getElementById('CartContainer');
    if (!container) return;

    // El mensaje de envío gratis se queda en su sitio de siempre
    // (la barra bajo la cabecera); aquí solo la ponemos en su
    // estado "vacío" (mensaje fijo, gris, sin progreso).
    renderEmptyShippingBar();

    // ".ajaxcart__empty-center" ocupa todo el espacio sobrante y
    // centra el título verticalmente; ".ajaxcart__empty-footer"
    // queda pegado al borde inferior (mismo criterio que el footer
    // del carrito con productos: Collect & Save + botón siempre
    // abajo). Ver snippets/cart-styles.liquid.
    // El slot de Collect & Save se deja VACÍO aquí a propósito:
    // antes se clonaba aquí mismo la plantilla entera sin ningún
    // límite, así que si la colección "upsell-carrito" tiene más de
    // 4 productos, se veían TODOS con el carrito vacío (en el grid
    // 2x2 de móvil eso además infla mucho la altura del footer y,
    // como ".ajaxcart__empty-center" puede encogerse hasta 0 para
    // dejarle sitio, empuja el título "carrito vacío" pegado arriba
    // en vez de centrado). renderCollectSave() de abajo es quien de
    // verdad rellena el slot, y ya aplica el mismo límite de 4
    // productos visibles (y el resto de lógica: título, último
    // visible, etc.) que usa el carrito con productos.
    container.innerHTML =
      '<div class="ajaxcart__empty">' +
        '<div class="ajaxcart__empty-center">' +
          '<p class="ajaxcart__empty-title">' + (theme.strings.cartEmptyTitle || '') + '</p>' +
        '</div>' +
        '<div class="ajaxcart__empty-footer">' +
          '<div id="CollectSaveSlot" class="ajaxcart__collect-save-slot" data-collect-save-slot></div>' +
          '<a href="/collections/frontpage" class="btn--secondary btn--full ajaxcart__explore">' + (theme.strings.cartExplore || '') + '</a>' +
        '</div>' +
      '</div>';

    renderCollectSave(cart);
  }

  /* ------------------------------------------------------------
     6b. Alineado del campo de código de descuento con el título
     ------------------------------------------------------------
     Calcular a ojo (con un % + unos px) dónde arranca el título del
     producto ha fallado varias veces: el resultado real del grid
     del tema (floats, gutters, etc.) no coincidía con el cálculo.
     En vez de seguir adivinando, medimos la posición REAL del
     título ya renderizado y la aplicamos como variable CSS: así el
     alineado es exacto siempre, sea cual sea el ancho del carrito o
     cualquier detalle del grid que no controlemos aquí. */
  function syncDiscountCodeIndent() {
    var titleWrapper = document.querySelector('#CartDrawer .ajaxcart__product-name--wrapper');
    var row = titleWrapper && titleWrapper.closest('.ajaxcart__row');
    var drawer = document.getElementById('CartDrawer');
    if (!titleWrapper || !row || !drawer) return;

    var indent = titleWrapper.getBoundingClientRect().left - row.getBoundingClientRect().left;
    if (indent > 0) {
      drawer.style.setProperty('--cart-discount-indent', indent + 'px');
    }
  }

  /* ------------------------------------------------------------
     6c. Imagen de los productos del carrito en mayor resolución
     ------------------------------------------------------------
     assets/theme.js (que no tocamos) fuerza el tamaño "_small" de
     Shopify para la miniatura del carrito — son solo 100x100px.
     Con la columna de imagen más ancha (35%, ver cart-styles.liquid)
     esa resolución tan baja se nota mucho más al estirarse. Las
     imágenes de Collect & Save no tienen este problema porque las
     pedimos nosotros mismos con su propio tamaño en cart-upsell.liquid.
     Aquí, después de cada render, cambiamos "_small" por un tamaño
     mayor directamente en el <img> ya pintado, sin tocar theme.js. */
  function upsizeCartItemImages() {
    var images = document.querySelectorAll('#CartDrawer .ajaxcart__product-image img');
    for (var i = 0; i < images.length; i++) {
      var img = images[i];
      var src = img.getAttribute('src') || '';
      if (/_small(\.[a-zA-Z0-9]+)/.test(src)) {
        img.src = src.replace(/_small(\.[a-zA-Z0-9]+)/, '_400x$1');
      }
    }
  }

  /* ------------------------------------------------------------
     7. Orquestación: qué hacer cada vez que el carrito se actualiza
  ------------------------------------------------------------ */
  function onCartUpdated(cart) {
    if (cart.item_count === 0) {
      renderEmptyCart(cart);
      return;
    }

    updateFreeShippingBar(cart);
    renderCollectSave(cart);
    syncDiscountCodeIndent();
    upsizeCartItemImages();

    var container = document.getElementById('CartContainer');
    if (container) bindDiscountCode(container);
  }

  function refreshCart(callback) {
    // ajaxCart solo expone públicamente `init` y `load` (ver
    // assets/theme.js, `module = { init: init, load: loadCart }`).
    // `load()` hace ShopifyAPI.getCart(cartUpdateCallback) →
    // buildCart(cart) → cartCallback(cart): buildCart es quien
    // realmente vacía y reconstruye #CartContainer con los items
    // actuales (incluido el que se acaba de añadir desde el
    // upsell), y cartCallback dispara el evento
    // 'ajaxCart.afterCartLoad' que ya escuchamos más abajo para
    // refrescar la barra de envío gratis y Collect & Save. Nada de
    // esto toca el estado abierto/cerrado del drawer, así que es
    // seguro llamarlo con el carrito ya abierto.
    if (window.ajaxCart && typeof ajaxCart.load === 'function') {
      ajaxCart.load();
      if (typeof callback === 'function') {
        $.getJSON('/cart.js', callback);
      }
      return;
    }

    // Fallback por si ajaxCart no está disponible por algún motivo:
    // al menos mantenemos la barra de envío y Collect & Save al día,
    // aunque la lista de items no se reconstruya.
    $.getJSON('/cart.js', function (cart) {
      onCartUpdated(cart);
      if (typeof callback === 'function') callback(cart);
    });
  }

  $(document).ready(function () {
    // Único punto de entrada: el propio plugin del carrito dispara
    // este evento cada vez que carga o actualiza el carrito,
    // incluida su carga inicial al entrar en la página.
    $('body').on('ajaxCart.afterCartLoad', function (evt, cart) {
      onCartUpdated(cart);
    });

    var popup = document.getElementById('CartSizePopup');
    if (popup) {
      var closeButtons = popup.querySelectorAll('[data-size-popup-close]');
      for (var i = 0; i < closeButtons.length; i++) {
        closeButtons[i].addEventListener('click', closeSizePopup);
      }
      var confirmAddButton = popup.querySelector('[data-size-popup-add]');
      if (confirmAddButton) {
        confirmAddButton.addEventListener('click', function () {
          addUpsellVariantToCart(sizePopupSelectedVariantId);
        });
      }
    }

    // Si la ventana cambia de tamaño con el carrito abierto (o el
    // usuario gira el móvil), el ancho del carrito puede cambiar, así
    // que recalculamos el alineado del código de descuento.
    var resizeTimer;
    $(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncDiscountCodeIndent, 150);
    });
  });
})(jQuery);

/* ==========================================================
   Collection load-more (AJAX)
   Used by the Shop / Last Units / Archive / Sale collection templates.
   Clicking the "Load more" button fetches the NEXT page through
   Shopify's section-rendering endpoint (?section_id=...) and APPENDS
   those products under the ones already on screen instead of navigating
   to a new page/URL — "stages unlocking", not real pages.
   See snippets/collection-pagination.liquid for the markup this reads
   (data-load-more, data-section-id, .grid-dynamic-cols/.grid-collage,
   .collection-pagination).
   ========================================================== */
(function () {
  function getGrid(root) {
    return root.querySelector('.grid-dynamic-cols, .grid-collage');
  }

  function handleClick(e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn || btn.classList.contains('is-loading')) return;
    e.preventDefault();

    var wrapper = btn.closest('#CollectionSection');
    var sectionId = wrapper && wrapper.getAttribute('data-section-id');
    var url = btn.getAttribute('href');
    if (!wrapper || !sectionId || !url) return;

    var sep = url.indexOf('?') > -1 ? '&' : '?';
    var fetchUrl = url + sep + 'section_id=' + encodeURIComponent(sectionId);
    var originalText = btn.textContent;

    btn.classList.add('is-loading');
    btn.textContent = '...';

    fetch(fetchUrl, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Load more request failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newGrid = getGrid(doc);
        var currentGrid = getGrid(wrapper);
        if (newGrid && currentGrid) {
          while (newGrid.firstChild) {
            currentGrid.appendChild(newGrid.firstChild);
          }
        }

        var newPagination = doc.querySelector('.collection-pagination');
        var currentPagination = wrapper.querySelector('.collection-pagination');
        if (newPagination && currentPagination) {
          currentPagination.replaceWith(newPagination);
        }

        // lazysizes watches the DOM for new .lazyload elements on its own,
        // this just nudges it in case that particular build needs a poke.
        document.dispatchEvent(new Event('lazybeforeunveil'));
      })
      .catch(function () {
        // Fetch failed for any reason (network, section_id mismatch, etc.)
        // — fall back to a normal full-page navigation so Load More still
        // works, it just reloads the page like plain Shopify pagination.
        window.location.href = url;
      })
      .finally(function () {
        if (document.body.contains(btn)) {
          btn.classList.remove('is-loading');
          btn.textContent = originalText;
        }
      });
  }

  document.addEventListener('click', handleClick);
})();

/* ---- Sale store countdown timer --------------------------------------
   Own widget for sections/collection-sale-template.liquid — independent
   from snippets/shopifyexplorer-countdown-timer.liquid used on the
   product page. Only shows Days/Hours/Minutes (no seconds), so it only
   needs to refresh every few seconds rather than every one. Reads the
   target date from each [data-sale-timer]'s data-timer-end attribute and
   fills in its data-timer-days/hours/minutes spans; hides the widget via
   .sale-timer--expired once the target date has passed. ------------- */
(function () {
  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function tick() {
    var timers = document.querySelectorAll('[data-sale-timer]');
    if (!timers.length) return;

    var now = new Date().getTime();

    timers.forEach(function (timer) {
      var endDate = timer.getAttribute('data-timer-end');
      if (!endDate) return;

      var end = new Date(endDate).getTime();
      if (isNaN(end)) return;

      var distance = Math.max(end - now, 0);

      var day = 1000 * 60 * 60 * 24;
      var hour = 1000 * 60 * 60;
      var minute = 1000 * 60;

      var days = Math.floor(distance / day);
      var hours = Math.floor((distance % day) / hour);
      var minutes = Math.floor((distance % hour) / minute);

      var daysEl = timer.querySelector('[data-timer-days]');
      var hoursEl = timer.querySelector('[data-timer-hours]');
      var minutesEl = timer.querySelector('[data-timer-minutes]');

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);

      timer.classList.toggle('sale-timer--expired', distance <= 0);
    });
  }

  tick();
  setInterval(tick, 15000);
})();